import {
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';
import CircleStyle from 'ol/style/Circle';

/**
 * Styles the handles use to move/resize the circle.
 */
export function getLineHandleStyle(): Style {
  const fillColor = 'white';

  return new Style({
    image: new CircleStyle({
      radius: 8,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: 'black', width: 2 }),
    }),
  });
}

export function getMidpointHandleStyle(): Style {
  const fillColor = 'white';

  return new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: 'black', width: 2 }),
    }),
    text: new Text({
      text: '+',
      font: '12px Arial',
      fill: new Fill({ color: 'black' }),
      offsetY: 1,
    }),
  });
}

export function getExtensionHandleStyle(): Style {
  const fillColor = 'white';
  return new Style({
    image: new CircleStyle({
      radius: 5,
      fill: new Fill({ color: fillColor }),
      stroke: new Stroke({ color: 'black', width: 2 }),
    }),
    text: new Text({
      text: '+',
      font: '12px Arial',
      fill: new Fill({ color: 'black' }),
      offsetY: 1,
    }),
  });
}
